// @ts-nocheck
import liveRequest from '@/utils/request';
import { getToken } from '@/utils/token';

const reFix = 'live';

//获取主播列表
export function getAllAnchors() {
  return liveRequest({
    url: reFix + '/Anchor/AllList',
    method: 'GET',
  });
}
//新增主播
export function addAnchor(userId, areaId) {
  return liveRequest({
    url: reFix + `/Anchor/add`,
    method: 'POST',
    data: { userId, areaId },
  });
}
//删除主播
export function removeAnchor(data) {
  return liveRequest({
    url: reFix + `/Anchor`,
    method: 'DELETE',
    data,
  });
}

//获取直播预告列表
export function getAdvanceNoticeList(params) {
  return liveRequest({
    url: reFix + `/LiveAdvanceNotice/page`,
    method: 'GET',
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    params: { ...params },
  });
}

//获取单个预告数据
export function getAdvanceNotice(id) {
  return liveRequest({
    url: reFix + `/LiveAdvanceNotice/${id}`,
    method: 'GET',
  });
}

//新增直播预告
export function addAdvanceNotice(data) {
  return liveRequest({
    url: reFix + `/LiveAdvanceNotice/add`,
    method: 'POST',
    data,
  });
}

//编辑直播预告
export function editAdvanceNotice(id, data) {
  return liveRequest({
    url: reFix + `/LiveAdvanceNotice/${id}`,
    method: 'PUT',
    data,
  });
}

//删除直播预告
export function removeAdvanceNotice(data) {
  return liveRequest({
    url: reFix + `/LiveAdvanceNotice`,
    method: 'DELETE',
    data,
  });
}

//获取预告动态列表
export function getAdvanceContentList(params) {
  return liveRequest({
    url: reFix + `/LiveAdvanceContent/page`,
    method: 'GET',
    params,
  });
}

//获取单个预告动态
export function getAdvanceContent(id) {
  return liveRequest({
    url: reFix + `/LiveAdvanceContent/${id}`,
    method: 'GET',
  });
}

//新增预告动态
export function addAdvanceContent(data) {
  return liveRequest({
    url: reFix + `/LiveAdvanceContent/add`,
    method: 'POST',
    data,
  });
}

//编辑预告动态
export function editAdvanceContent(id, data) {
  return liveRequest({
    url: reFix + `/LiveAdvanceContent/${id}`,
    method: 'PUT',
    data,
  });
}

//删除预告动态
export function removeAdvanceContent(data) {
  return liveRequest({
    url: reFix + `/LiveAdvanceContent`,
    method: 'DELETE',
    data,
  });
}

//上传预告和直播动态图片
export function liveUpload(data) {
  return liveRequest({
    url: 'upload/Images/upload',
    method: 'POST',
    data,
  });
}
